export const markdownStyles = `
  .markdown-body { 
    font-size: 14px;
    line-height: 1.5;
  }
  .markdown-body table {
    margin: 0.5em 0;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    width: 100%;
  }
  .markdown-body thead {
    background: rgba(0, 0, 0, 0.3);
    border-bottom: 2px solid rgba(255, 255, 255, 0.15);
  }
  .markdown-body thead th {
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 1) !important;
    font-size: 13px;
    padding: 12px 16px;
    text-align: left;
    background: transparent !important;
  }
  .markdown-body tbody tr {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  .markdown-body tbody tr:last-child {
    border-bottom: none;
  }
  .markdown-body tbody tr:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  .markdown-body td {
    padding: 12px 16px;
    color: rgba(255, 255, 255, 0.8);
  }
  .markdown-body p {
    margin: 0.5em 0;
  }
  .markdown-body p:first-child {
    margin-top: 0;
  }
  .markdown-body p:last-child {
    margin-bottom: 0;
  }
  .markdown-body pre {
    margin: 0.5em 0;
  }
  .markdown-body pre:first-child {
    margin-top: 0;
  }
  .markdown-body pre:last-child {
    margin-bottom: 0;
  }
  .markdown-body ul, .markdown-body ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
  }
  .markdown-body ul:first-child, .markdown-body ol:first-child {
    margin-top: 0;
  }
  .markdown-body ul:last-child, .markdown-body ol:last-child {
    margin-bottom: 0;
  }
  .table-download-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: all 0.2s;
  }
  .table-download-btn:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  .markdown-table-wrap {
    position: relative;
  }

  @media (max-width: 768px) {
    .markdown-body {
      font-size: 13px;
    }
    .markdown-body thead th {
      font-size: 12px;
      padding: 8px 12px;
    }
    .markdown-body td {
      padding: 8px 12px;
    }
    .markdown-body table {
      margin: 0.25em 0;
    }
    .markdown-body ul, .markdown-body ol {
      padding-left: 1.2em;
    }
    .markdown-body pre {
      margin: 0.25em 0;
    }
    .table-download-btn {
      padding: 3px 6px;
      font-size: 11px;
    }
  }

  @media (max-width: 480px) {
    .markdown-body {
      font-size: 12px;
    }
    .markdown-body thead th {
      font-size: 11px;
      padding: 6px 8px;
    }
    .markdown-body td {
      padding: 6px 8px;
    }
    .markdown-body table {
      margin: 0.2em 0;
    }
    .markdown-body ul, .markdown-body ol {
      padding-left: 1em;
    }
    .markdown-body pre {
      margin: 0.2em 0;
    }
    .table-download-btn {
      padding: 2px 4px;
      font-size: 10px;
    }
  }
`;